import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-reception-chaudiere',
  templateUrl: './service-reception-chaudiere.component.html',
  styleUrls: ['./service-reception-chaudiere.component.scss']
})
export class ServiceReceptionChaudiereComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
